import React from 'react';
import { Navigate, Outlet, useLocation, useNavigationType } from 'react-router';
import { useAuth } from '../context/AuthProvider';

export const ProtectedRoute: React.FC = () => {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();
  const navigationType = useNavigationType();

  if (isLoading || !navigationType) {
    return null;
  }

  if (!currentUser?.member) {
    return (
      <Navigate
        to="/login"
        state={navigationType === 'POP' ? { from: location } : {}}
        replace
      />
    );
  }

  return <Outlet />;
};
